export interface UserVeriffVerificationStatus {
  verified?: boolean;
  status?: VeriffStatus;
  errorReason?: VeriffErrorCode | null | undefined;
}

export enum VeriffStatus {
  STARTED = 'STARTED',
  VERIFIED = 'VERIFIED',
  EXPIRED = 'EXPIRED',
  DECLINED = 'DECLINED',
  COMPLETED = 'COMPLETED',
}

export enum VeriffErrorCode {
  DOCUMENT_QUALITY_ISSUE = 'DOCUMENT_QUALITY_ISSUE',
  DOCUMENT_VALIDITY_ISSUE = 'DOCUMENT_VALIDITY_ISSUE',
  IDENTITY_MATCH_PROBLEM = 'IDENTITY_MATCH_PROBLEM',
  TECHNICAL_ISSUE = 'TECHNICAL_ISSUE',
  MISSING_INFORMATION = 'MISSING_INFORMATION',
  COMPLIANCE_ISSUE = 'COMPLIANCE_ISSUE',
  NAME_MISMATCH = 'NAME_MISMATCH',
}

export const errorCodeToTranslationKey: Record<VeriffErrorCode, string> = {
  [VeriffErrorCode.DOCUMENT_QUALITY_ISSUE]: 'errors.veriff.quality.issue',
  [VeriffErrorCode.DOCUMENT_VALIDITY_ISSUE]: 'errors.veriff.validity.issue',
  [VeriffErrorCode.IDENTITY_MATCH_PROBLEM]: 'errors.veriff.identity.match',
  [VeriffErrorCode.TECHNICAL_ISSUE]: 'errors.veriff.technical',
  [VeriffErrorCode.MISSING_INFORMATION]: 'errors.veriff.missing.info',
  [VeriffErrorCode.COMPLIANCE_ISSUE]: 'errors.veriff.compliance',
  [VeriffErrorCode.NAME_MISMATCH]: 'errors.veriff.name.mismatch',
};

export const getErrorTranslationKey = (errorCode: VeriffErrorCode | null | undefined): string => {
  if (errorCode === null || errorCode === undefined) {
    return 'VerificationLandingPage.errorMessage';
  }
  return errorCodeToTranslationKey[errorCode] || 'VerificationLandingPage.errorMessage';
};
